// extracted by mini-css-extract-plugin
export default {"template-single__add":"SingleTipAdd_template-single__add__DRUQH","template-single__add__border":"SingleTipAdd_template-single__add__border__icgRW"};